import * as React from 'react';
export const coastalfederalSvg = React.forwardRef(
  function coastalfederalSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#08A84E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M22.726 22.975v-.002c-.053-.065-3.133-1.512-6.649 2.406L15.697 28H10l4.517-1.17 1.732-15.283-.299-2.023s.535-.463 1.333-.817l.327-3.283L19.143 4l-.49 1.388c.3-.01.644.036 1.007.181-.3.027-.535.082-.753.145l-.154 2.622c.93 0 1.78.178 2.621.598-.571-.09-1.741-.2-2.576.145-1.134.472-1.37.998-1.37.998l.019.644a3.972 3.972 0 0 1 1.995.263 3.656 3.656 0 0 0-1.342.435l-.29 1.978c1.795-.563 3.201-.254 3.773-.073l.344 2.93c-1.529-.44-3.335.051-4.662.862l-.48 3.301c1.616-.905 3.665-1.358 5.505-1.125l.435 3.681v.002Z',
        fill: '#fff',
      }),
    );
  },
);
coastalfederalSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var coastalfederal = {
  category: 'brand',
  colorable: false,
  name: 'coastalfederal',
  svg: coastalfederalSvg,
};
